// draft.js - auto-save of in-progress evaluations into localStorage.
// Drafts are keyed by player + team + coach code so two coaches sharing a
// device never overwrite each other.

import { UTILS } from './utils.js';

export const DRAFT = (() => {

  function save(playerId, teamId, code, state) {
    const key = UTILS.draftKey(playerId, teamId, code);
    UTILS.lsSet(key, {
      ratings:      state.ratings      || {},
      comments:     state.comments     || {},
      strongPoints: state.strongPoints || '',
      workingPoints:state.workingPoints|| '',
      sessionNotes: state.sessionNotes || '',
      savedAt:      UTILS.today(),
    });
  }

  // Returns the draft or null. Skips drafts that exist but carry no meaningful
  // edits (handles the "started typing then cleared" leftover state).
  function load(playerId, teamId, code) {
    const data = UTILS.lsGet(UTILS.draftKey(playerId, teamId, code));
    if (!data) return null;
    const hasRatings  = Object.values(data.ratings || {}).some(v => v > 0);
    const hasFeedback = data.strongPoints || data.workingPoints || data.sessionNotes;
    if (!hasRatings && !hasFeedback) return null;
    return data;
  }

  function clear(playerId, teamId, code) {
    UTILS.lsRemove(UTILS.draftKey(playerId, teamId, code));
  }

  // Every draft for one coach's code. Used by the sign-out flow so the
  // coach can see that work-in-progress is being left behind on the device.
  function findForCode(code) {
    if (!code || typeof localStorage === 'undefined') return [];
    const suffix = `_${code}`;
    const out = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key || !key.startsWith('draft_') || !key.endsWith(suffix)) continue;
      const rest = key.slice('draft_'.length, -suffix.length);
      const sep  = rest.lastIndexOf('_');
      if (sep <= 0) continue;
      const playerId = rest.slice(0, sep);
      const teamId   = rest.slice(sep + 1);
      const data     = load(playerId, teamId, code);
      if (data) out.push({ playerId, teamId, savedAt: data.savedAt || '' });
    }
    return out;
  }

  return { save, load, clear, findForCode };

})();
